import { connect } from 'react-redux';
import PembagianKelasKhusus from '../../../views/Akademi/DataKelas/PembagianKelasKhusus.view';
import { addBudget } from '../../../states/thunks/finance.thunk';
import { getClasses,getLevels, getPeriodsOptions } from '../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    user: state.user,
    classes: state.options.classes,
    levels: state.options.levels,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetClasses: (payload) => dispatch(getClasses(payload)),
    handleGetLevels: payload => dispatch(getLevels(payload)),
    handleAddBudget: (payload, goBack, unit_id) => dispatch(addBudget(payload, goBack, unit_id)),
    getPeriodsOptions: (payload) => dispatch(getPeriodsOptions(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PembagianKelasKhusus);